import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  ogUrl?: string;
  canonicalUrl?: string;
  robots?: string;
  structuredData?: object;
}

const SEOHead: React.FC<SEOHeadProps> = ({
    title = "MYKOKU Parent App",
    description = "Find talent class - Badminton, Swimming, STEM, Magic, Chess and more! Content trusted by schools across Malaysia SK, SJKC, SMK & SMJK.",
    keywords = "MyKoku parent portal, talent class Malaysia, school management system, badminton class, swimming class, chess class, STEM Malaysia, SJKC, SMK, SK, school attendance, online learning platform",
    ogTitle,
    ogDescription,
    ogImage = `${process.env.PUBLIC_URL}/assets/img/koku-logo.png`,
    ogUrl = "https://parent.mykokurikulum.com/",
    canonicalUrl,
    robots = "index, follow",
    structuredData
}) => {
    const finalOgTitle = ogTitle || title;
    const finalOgDescription = ogDescription || description;
    const finalCanonicalUrl = canonicalUrl || ogUrl;

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            <meta name="robots" content={robots} />
            <link rel="canonical" href={finalCanonicalUrl} />
            
            {/* Open Graph */}
            <meta property="og:title" content={finalOgTitle} />
            <meta property="og:description" content={finalOgDescription} />
            <meta property="og:image" content={ogImage} />
            <meta property="og:url" content={ogUrl} />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="MyKoku" />
            <meta property="og:locale" content="en_MY" />
            
            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={finalOgTitle} />
            <meta name="twitter:description" content={finalOgDescription} />
            <meta name="twitter:image" content={ogImage} />
            
            {/* Structured Data */}
            {structuredData && (
                <script type="application/ld+json">
                {JSON.stringify(structuredData)}
                </script>
            )}
        </Helmet>
    )
}

export default SEOHead;
